import { useEffect, useRef, useState } from 'react'
import { Stack, Text, XStack } from 'tamagui'
import { Icon } from '../../ui'

/**
 * Pop-on-press reaction/footer button — post card footer (like/share) and the
 * post detail screen (like) share this. `onPress` optional (e.g. an inert
 * "Share" placeholder); `count` shown when given, else `label`.
 */
export function ReactionButton({
  icon,
  count,
  label,
  onPress,
}: {
  icon: string
  count?: number
  label?: string
  onPress?: () => void
}) {
  // Bouncy pop of the icon when the action fires — transform only.
  const [pop, setPop] = useState(false)
  const popTimer = useRef<ReturnType<typeof setTimeout> | null>(null)
  // очистка при размонтировании — иначе setPop стреляет по мёртвому компоненту
  useEffect(() => () => {
    if (popTimer.current) clearTimeout(popTimer.current)
  }, [])
  const press = onPress
    ? () => {
        if (popTimer.current) clearTimeout(popTimer.current)
        setPop(true)
        popTimer.current = setTimeout(() => setPop(false), 260)
        onPress()
      }
    : undefined
  return (
    <XStack
      onPress={press}
      cursor={onPress ? 'pointer' : 'default'}
      alignItems="center"
      gap={6}
      paddingHorizontal={12}
      paddingVertical={6}
      borderRadius={5}
      animation="quick"
      hoverStyle={onPress ? { backgroundColor: '$backgroundHover' } : {}}
      pressStyle={onPress ? { scale: 0.92 } : {}}
    >
      <Stack animation="bouncy" scale={pop ? 1.35 : 1}>
        <Icon name={icon} size={16} color="$muted" />
      </Stack>
      <Text fontSize={13} fontWeight="500" color="$muted">
        {count != null ? count : label}
      </Text>
    </XStack>
  )
}
